import React, { useState } from 'react';

import { ToggleButton } from 'components';
import { TextalignCenter, TextalignLeft, TextalignRight } from 'iconsax-react';

import { RadioGroupInput } from './RadioGroupInput';

type Props = {
  label: string;
  defaultValue: string | null;
  onChange: (value: string | null) => void;
};

export const TextAlignInput: React.FC<Props> = ({
  label,
  defaultValue,
  onChange,
}) => {
  const [value, setValue] = useState(defaultValue ?? 'left');

  return (
    <RadioGroupInput
      label={label}
      defaultValue={value}
      onChange={value => {
        setValue(value);
        onChange(value);
      }}
    >
      <ToggleButton value="left">
        <TextalignLeft variant="TwoTone" size="20" />
      </ToggleButton>
      <ToggleButton value="center">
        <TextalignCenter variant="TwoTone" size="20" />
      </ToggleButton>
      <ToggleButton value="right">
        <TextalignRight variant="TwoTone" size="20" />
      </ToggleButton>
    </RadioGroupInput>
  );
};
